import { memo } from 'react';

import { StyledTextField } from './input.style';

export interface InputProps {
  disabled?: boolean;
  name?: string;
  placeholder?: string;
  value: string | null;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = ({
  value,
  name,
  placeholder,
  onChange,
  disabled,
}: InputProps) => (
  <StyledTextField
    disabled={disabled}
    name={name}
    placeholder={placeholder}
    value={value}
    variant="standard"
    onChange={onChange}
    InputProps={{
      disableUnderline: true,
    }}
  />
);

export default memo(Input);
